<template>
  <span>
    <!-- <pre>{{ contactHistoryIDList }}</pre> -->
    <!-- <pre>{{ changeValueContact }}</pre> -->
    <!-- <pre>{{ formSubscribe }}</pre> -->
    <!-- <pre>{{ dataProfile }}</pre> -->
    <!-- <pre>{{ formData }}</pre> -->
    <!-- <pre>{{ contacHistorytDataList }}</pre> -->
    <a-form class="mt-10" :layout="'horizontal'">
      <a-row v-if="contactHistoryIDList.length != 0">
        <a-col :span="24" style="text-align: right">
          <a-button type="primary" @click="isVisibleContactHist = true">
            View History
          </a-button>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="10" :offset="2">
          <a-form-item label="Address" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
            <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formData.address" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="10" :offset="2">
          <a-form-item label="Email" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
            <a-input type="email" v-model="formData.email" placeholder="" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="10" :offset="2">
          <a-form-item label="Home Phone" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
            <a-input v-model="formData.phone_home" placeholder="" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="10" :offset="2">
          <a-form-item label="Mobile Phone" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
            <a-input v-model="formData.phone_number" placeholder="" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="10" :offset="2">
          <a-form-item label="Facebook" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
            <a-input v-model="formData.social_facebook" placeholder="" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="10" :offset="2">
          <a-form-item label="IG" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" extra="">
            <a-input v-model="formData.social_instagram" placeholder="" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="10" :offset="5">
          <a-checkbox v-model="formSubscribe.unsubscribe">
            Unsubscribe
          </a-checkbox>
        </a-col>
      </a-row>
      <!-- Submit button -->
      <a-row class="mt-20">
        <a-col :span="10" :offset="5">
          <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
            <a-button @click="isVisibleConfirm = true" type="primary" class="mr-10">
              Submit
            </a-button>
            <a-button @click="backTomain" type="danger"> Back </a-button>
          </a-form-item>
        </a-col>
      </a-row>
      <!-- End -->
    </a-form>

    <!-- Modal Confirm -->
    <a-modal title="Confirm" :visible="isVisibleConfirm" @ok="submitForm" @cancel="isVisibleConfirm = false">
      <p>Are you sure to Submit ?</p>
    </a-modal>
    <!-- Close Modal Confirm -->

    <!-- Modal Confirm -->
    <a-modal title="Contact History" :visible="isVisibleContactHist" width="1200px" @ok="isVisibleContactHist = false"
      @cancel="isVisibleContactHist = false">
      <!-- @getProfileMain="getProfileMain" -->
      <ContactTable :dataTable="contacHistorytDataList" @deleteID="updateChildcontact" />
    </a-modal>
    <!-- Close Modal Confirm -->
  </span>
</template>

<script>
import ContactTable from "./Contact/ContactTable.vue";

const formContact = {
  id: "",
  phone_home: "",
  phone_number: "",
  social_line: "",
  social_facebook: "",
  social_instagram: "",
  email: "",
  address: "",
  updated_at: "",
  created_at: "",
};
const formSubscribe = {
  unsubscribe: false,
};

export default {
  components: {
    ContactTable,
  },
  props: {
    dataProfile: {
      type: Array,
      default: () => [],
    },
    getProfileMain: { type: Function },
  },
  data() {
    return {
      formData: Object.assign({}, formContact),
      formDataDefault: Object.assign({}, formContact),
      formSubscribe: Object.assign({}, formSubscribe),
      contactHistoryIDList: [],
      contacHistorytDataList: [],
      isVisibleConfirm: false,
      isVisibleContactHist: false,
      subscribe_status: true,
      isDataContactChange: false,
    };
  },
  mounted() {
    this.setDefaultData();
  },
  watch: {
    "formData.phone_home"(val) {
      this.isDataContactChange = this.checkDataContactChange(val);
    },
    "formData.phone_number"(val) {
      this.isDataContactChange = this.checkDataContactChange(val);
    },
    "formData.social_facebook"(val) {
      this.isDataContactChange = this.checkDataContactChange(val);
    },
    "formData.social_instagram"(val) {
      this.isDataContactChange = this.checkDataContactChange(val);
    },
    "formData.email"(val) {
      this.isDataContactChange = this.checkDataContactChange(val);
    },
    "formData.address"(val) {
      this.isDataContactChange = this.checkDataContactChange(val);
    },
  },
  methods: {
    backTomain() {
      this.$router
        .push({
          path: "/alumni/",
        })
        .catch((err) => { });
    },
    setDefaultData() {
      console.log("setDefaultData contact");
      this.formSubscribe.unsubscribe =
        this.dataProfile[0].length != 0
          ? !this.dataProfile[0].subscribe
          : false;


      if (this.dataProfile[0].contact_detail.length != 0) {
        this.contactHistoryIDList = this.dataProfile[0]["alumin_contact"];
        this.contacHistorytDataList = this.dataProfile[0]["contact_detail"];
        this.formData = Object.assign(
          {},
          this.dataProfile[0]["contact_detail"][
          this.dataProfile[0]["contact_detail"].length - 1
          ]
        );
        this.formDataDefault = Object.assign(
          {},
          this.dataProfile[0]["contact_detail"][
          this.dataProfile[0]["contact_detail"].length - 1
          ]
        );
      } else {
        this.formData = Object.assign({}, formContact)
      }
    },
    updateChildcontact(...args) {
      // //console.log(args[0].dataId);
      var jsonBodyContact = {}
      this.$emit("updateMainContact", { dataIdDelMain: args[0].dataId });
      const indexDel = this.contacHistorytDataList.findIndex(
        (itemDel) => itemDel.id === args[0].dataId
      );
      const indexDelID = this.contactHistoryIDList.findIndex(
        (itemDel) => itemDel === args[0].dataId
      );
      this.contacHistorytDataList.splice(indexDel, 1);
      this.contactHistoryIDList.splice(indexDelID, 1);
      jsonBodyContact["alumin_contact"] = this.contactHistoryIDList;
      this.updateContact(jsonBodyContact);
    },
    checkDataContactChange() {
      if (this.dataProfile[0]["alumin_contact"].length == 0) {
        //case never have contact data
        return true;
      } else {
        // //console.log(this.formDataDefault);
        return (
          JSON.stringify(this.formData) !== JSON.stringify(this.formDataDefault)
        );
      }
    },
    updateContact(jsonData) {
      // //console.log(jsonData);
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-profile/" + this.dataProfile[0].id + "/",
            jsonData
          )
          .then((response) => {
            if (response.status) {
              this.$emit("updateObjMainProfile", { data: response.data });
              this.setDefaultData();
              this.isDataContactChange = false;
              this.isVisibleConfirm = false;
              this.$emit("successNotification", {
                msg: "Success",
                des: `profile contact update`,
              });
              resolve(true);
            }
          })
          .catch((error) => {
            //console.log(error);
            resolve(false);
          });
      });
    },
    async submitForm() {
      // //console.log(this.isDataContactChange);
      var jsonBodyMain = {
        subscribe: !this.formSubscribe.unsubscribe,
      };
      console.log(jsonBodyMain);
      if (this.isDataContactChange) {
        // //console.log("Hi");
        try {
          var jsonContact = {
            social_facebook: this.formData.social_facebook,
            phone_home: this.formData.phone_home,
            phone_number: this.formData.phone_number,
            social_instagram: this.formData.social_instagram,
            email: this.formData.email,
            address: this.formData.address,
          };
          const response = await this.$http.post(
            "/student_affair/alumni-profile-contact/",
            jsonContact
          );
          console.log(jsonContact);
          if (response.status === 201) {
            this.contactHistoryIDList.push(response.data.id);
            jsonBodyMain["alumin_contact"] = this.contactHistoryIDList;
            this.updateContact(jsonBodyMain);
          } else {
            throw { response };
          }
        } catch (error) {
          this.$notification['error']({
            message: function (h) {
              return h("div", [
                h("strong", { class: "" }, `Failed to connect to the API`),
              ]);
            },
            description:
              `Error ${error.response.status} : /student_affair/alumni-profile-contact/`,
          });
        }
      } else {
        this.updateContact(jsonBodyMain);
      }
    },
  },
};
</script>
